/**
 * 子管理员模块接口列表
 */

import base from './base'; // 导入接口域名列表
import axios from './axios';
import qs from 'qs';

//获取子管理员列表（交易员列表）
export const getListTrader = (params)=>{
  return axios.post(`${base.base}/trader/get_list_trader`,
    qs.stringify(params)
  )
};

//获取子管理员（交易员）所管理会员（客户）列表
export const getListTraderClient = (params)=>{
  return axios.post(`${base.base}/trader/get_list_trader_client`,
    qs.stringify(params)
  )
};

//获取尚未分配管理员的会员（客户）列表
export const getListTraderNone = (params)=>{
  return axios.post(`${base.base}/trader/get_list_trader_none`,
    qs.stringify(params)
  )
};

//添加子管理员（交易员）
export const insertTrader = (params)=>{
  return axios.post(`${base.base}/trader/insert_trader`,
    qs.stringify(params)
  )
};

//删除子管理员（交易员）
export const deleteTrader = (params)=>{
  return axios.post(`${base.base}/trader/delete_trader`,
    qs.stringify(params)
  )
};

//重置子管理员（交易员）登录密码为 123456
export const defaultTraderPassword = (params)=>{
  return axios.post(`${base.base}/trader/default_trader_password`,
    qs.stringify(params)
  )
};

//更新子管理员（交易员）googlekey
export const updateTraderGooglekey = (params)=>{
  return axios.post(`${base.base}/trader/update_trader_googlekey`,
    qs.stringify(params)
  )
};

//更新子管理员（交易员）登录密码
export const updateTraderPassword = (params)=>{
  return axios.post(`${base.base}/trader/update_trader_password`,
    qs.stringify(params)
  )
};

//更新会员（客户）所属交易员
export const updateClientTrader = (params)=>{
  return axios.post(`${base.base}/trader/update_client_trader`,
    qs.stringify(params)
  )
};
//一键平仓
export const end = (params)=>{
  return axios.post(`${base.base}/trader/end`,
    qs.stringify(params)
  )
};
//全部平仓
export const endAll = (params)=>{
  return axios.post(`${base.base}/trader/end_all`,
    qs.stringify(params)
  )
};


export default getListTrader;



// WEBPACK FOOTER //
// ./src/api/trader.js